import React from 'react';
import { EmptyState } from '../../../../../CommonComponents/OPL/AsyncStates/EmptyState/EmptyState';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { PositionsTableSkeleton } from './components/PositionsTableSkeleton';

interface PositionsTableEmptyProps {
  isEmbeddedMobile: boolean;
}

export const PositionsTableEmpty = ({ isEmbeddedMobile }: PositionsTableEmptyProps) => {
  return (
    <PositionsTableSkeleton isEmbeddedMobile={isEmbeddedMobile}>
      <Box p="56" bg="bg">
        <EmptyState />
      </Box>
    </PositionsTableSkeleton>
  );
};
